/**
 * DynamoDB データインポート用ファイル
 *************************************************/
import React, { FC, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { createCategory, createQuiz } from 'graphql/mutations';
import { categoryDataList, quizDataList } from 'components/DataImport/data';

const DataImport: FC = () => {
  useEffect(() => {
    (() => {
      try {
        // 新規登録 カテゴリ
        categoryDataList.forEach((categoryData: any) => {
          API.graphql(graphqlOperation(createCategory, { input: categoryData }));
        });

        // 新規登録 カテゴリ
        quizDataList.forEach((quizData: any) => API.graphql(graphqlOperation(createQuiz, { input: quizData })));
      } catch (e) {
        console.log(e);
      }
    })();
  }, []);

  return <></>;
};
export default DataImport;
